import { ControllerRenderProps } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { getAreaType } from "@/sideEffects/api";
import React from "react";
import { useSelector } from "react-redux";
import { selectActiveFirm } from "@/store/appSelectors";
import { useTranslation } from "react-i18next";
import { AppSelect } from "@/components/ui/app-select";

export const AreaTypeSelect: React.FC<{
  field: ControllerRenderProps<any>;
}> = ({ field }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  const { data: areaTypeData, isLoading: isAreaTypeLoading } = useQuery({
    queryFn: () =>
      getAreaType({ pageNumber: 1, numberOfObjectsPerPage: 999999 }, { Firm_Id: String(activeFirm?.firmGuid) }),
    queryKey: ["getAreaType"],
  });

  const options = (areaTypeData?.data?.result || []).map((r) => ({
    value: r.intId,
    label: r.name,
    icon: (
      <div
        className="rounded-md w-[25px] h-[25px] border"
        style={{
          backgroundColor: r.color,
        }}
      >
        &nbsp;
      </div>
    ),
  }));

  const isLoading = isAreaTypeLoading;

  return (
    <AppSelect
      value={field.value}
      onChange={field.onChange}
      options={options}
      isLoading={isLoading}
      placeholder={t("entities.areaType")}
      label={t("entities.areaType")}
    />
  );
};
